import addTour from './addTour.js';
import editTour from './editTour.js';
import addDayType from './addDayType.js';
import editDayType from './editDayType.js';
import addAssignment from './addAssignment.js';
import deleteAssignment from './deleteAssignment.js';
import editAssignment from './editAssignment.js';


const generateNewOptimisticItem = async (operation, itemDetails, optimisticLiveSchedule, dayTypesAll, dayTypesAllowTour, resourceId) => {
  let newItem;
  if (operation === 'addTour') {
    newItem = addTour(itemDetails, dayTypesAllowTour);
  }
  if (operation === 'editTour') {
    newItem = editTour(itemDetails, optimisticLiveSchedule, dayTypesAllowTour, resourceId);
  }
  if (operation === 'addDayType') {
    newItem = addDayType(itemDetails, dayTypesAll);
  }
  if (operation === 'editDayType') {
    newItem = editDayType(itemDetails, optimisticLiveSchedule, dayTypesAll, dayTypesAllowTour, resourceId);
  }
  if (operation === 'addAssignment') {
    newItem = addAssignment(itemDetails, optimisticLiveSchedule, dayTypesAll, dayTypesAllowTour, resourceId);
  }
  if (operation === 'deleteAssignment') {
    newItem = deleteAssignment(itemDetails, optimisticLiveSchedule, dayTypesAllowTour, resourceId);
  }
  if (operation === 'editAssignment') {
    newItem = editAssignment(itemDetails, optimisticLiveSchedule, dayTypesAll, dayTypesAllowTour, resourceId);
  }

  return newItem;
}

export default generateNewOptimisticItem;
